import { useState } from "react";
import { toast } from "sonner";
import { QuestionInterface } from "../../../domain/interfaces/question_interface";
import TextAreaComment from "./textarea_comment";
import { AnswerInterface } from "../../../domain/interfaces/answer_interface";
import { useTranslation } from "../../../../../i18n/useTranslation";

interface StringQuestionProps {
    question: QuestionInterface;
    color: string;
    onValidate: (answer: AnswerInterface, initialAnswer?: AnswerInterface) => void;
}

const StringQuestion: React.FC<StringQuestionProps> = ({ question, color, onValidate }) => {
    const { t } = useTranslation();
    const [ comment, setComment ] = useState<string>(question.initialAnswer?.answer as string | undefined || "");
    return (
        <div className="flex flex-col items-center gap-5 max-w-94.5 w-full">
            <p
                className="bg-white font-bold text-xl leading-tight px-9 py-4 text-center rounded-[20px] aspect-3/2 flex items-center justify-center w-full"
                style={{ 
                    color: color,
                    boxShadow: '0 0 4px rgba(0, 0, 0, 0.04), 0 8px 16px rgba(0, 0, 0, 0.08)',
                }}
            >
                {question.question}
            </p>
            <form
                className="w-full"
                id={`question-${question.id}`}
                onSubmit={(e) => {
                    e.preventDefault();
                    if (comment.trim() === "") {
                        toast.error(t('survey.answer_required'));
                    } else {
                        onValidate({
                            questionId: question.id,
                            answer: comment,
                            text: "",
                        }, question.initialAnswer);
                    }
                }}
            >
                <TextAreaComment rows={5} placeholder={t('survey.answer_placeholder')} onCommentChange={(value: string) => setComment(value)} comment={comment}/>
            </form>
        </div>
    );
}

export default StringQuestion;